const modulesFiles = require.context('./', true, /\.ts$/);
// import module
modulesFiles.keys().forEach(modulePath => {
    modulesFiles(modulePath);
});
